import { StaticImage } from "gatsby-plugin-image"
import * as React from "react"

export function BrandLogoLight() {
  return (
    <StaticImage
      src="../logo/NR-Logo_footer.svg"
      alt="Logo"
      style={{ width: "200px" }}
      objectFit={"contain"}
    />
  )
}

export function BrandLogoDark() {
  return (
    <StaticImage
      src="../logo/NR-Logo_main.svg"
      alt="Logo"
      style={{ height: "100px", width: "100px" }}
      objectFit={"contain"}
    />
  )
}
